/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import {
  Game, AddonExtension, GameState, ActiveAddonExtension,
} from './types';
import { MutationRequestStatus, RootState } from '../types';
import { isFailure, isLoading, isSuccess } from '@a/store/utils';

export const getters: GetterTree<GameState, RootState> = {
  game(state): Game {
    return state.game.data;
  },

  isModsLoading: (state) => state.mods.status === MutationRequestStatus.LOADING,
  isModsReady: (state) => state.mods.status === MutationRequestStatus.SUCCESS,
  isModsFailure: (state) => state.mods.status === MutationRequestStatus.ERROR,

  allMods: (state) => state.mods.data && state.mods.data.mods,
  popularMods: (state) => state.mods.data
    && state.mods.data.mods.filter((m) => m.tags.includes('popular')),
  groupedMods: (state: GameState) => (
    (state.groupedMods.data != null) ? state.groupedMods.data : []
  ),
  modTags: (state) => state.mods.data && state.mods.data.tags,
  worker: (state) => state.worker,

  availableExtensions: (state) : Array<AddonExtension> => state.extensions.data,
  isAvailableExtensionsLoading:
    (state) : boolean => isLoading(state.extensions),
  isAvailableExtensionsSuccess:
    (state) : boolean => isSuccess(state.extensions),
  isAvailableExtensionsFailure:
    (state) : boolean => isFailure(state.extensions),

  activeModspaceExtension:
    (state) : ActiveAddonExtension | boolean => state.activeModspaceExtension.data,
  activeModspaceExtensionUnits: (state) : number => {
    if (!isSuccess(state.activeModspaceExtension) || state.activeModspaceExtension.data === null) {
      return undefined;
    }

    return state.activeModspaceExtension.data.addonUnits;
  },

  isActiveModspaceExtensionLoading:
    (state) : boolean => isLoading(state.activeModspaceExtension),
  isActiveModspaceExtensionSuccess:
    (state) : boolean => isSuccess(state.activeModspaceExtension),
  isActiveModspaceExtensionFailure:
    (state) : boolean => isFailure(state.activeModspaceExtension),
};
